/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
export const KEYCLOAK_VALIDATION_ERROR_STATUS_CODES: number[] = [400, 409];

export enum KeycloakFieldName {
  USERNAME = 'username',
  EMAIL = 'email',
}

export enum KeycloakErrorMessage {
  USERNAME_IS_MISSING = 'User name is missing',
  EMAIL_EXISTS = 'User exists with same email',
  USERNAME_EXISTS = 'User exists with same username',
  INVALID_LENGTH = 'error-invalid-length',
  INVALID_EMAIL = 'error-invalid-email',
}

export interface ErrorRepresentation {
  errorMessage?: KeycloakErrorMessage;
  field?: KeycloakFieldName;
  params?: any[];
}

export interface KeycloakHttpErrorResponse {
  response: {
    status: number;
  };
  responseData: KeycloakErrorResponseData;
}

export interface KeycloakErrorResponseData extends ErrorRepresentation {
  errors?: ErrorRepresentation[];
}
